import { atom } from "jotai";

export interface SampleCountStats {
    order_count: number;
    conversion_rate: number;
    time_to_convert: number;
    order_percentage: number;
    converted_average_order_value: number;
}
export interface AverageFulfillmentTime {
    avg_hours: number;
    avg_interval: string;
    fulfilled_orders: number;
    total_orders: number;
}

export interface BrandItemizedDesign {
    name: string;
    count: number;
}

export interface BrandDesignTotals {
    brands: number;
    shopify_connections: number;
    designs: number;
    itemized_designs: BrandItemizedDesign[];
    brands_uploading: number;
}

export interface BrandDesignData {
    totals: BrandDesignTotals;
    week: BrandDesignTotals;
}

export interface WallmatesAnalytics {
    gmv_total: string;
    gross_revenue: string;
    net_revenue: string;
    order_count: number;
    average_order_value: string;
    sample_order_percentage: string;
    average_sqft_per_order: string;
    average_sample_count_per_order: string;
    sample_data_by_sample_count: Record<string, SampleCountStats>;
    new_customers: number;
    previous_period_new_customers: number;
    customer_growth_rate: string;
    non_sample_average_order_value: string;
    sampler_count: string;
    one_shot_count: string;
    brand_design_data: BrandDesignData;
    avg_hours: string;
    avg_interval: string;
    fulfilled_orders: number;
    materials_tracking: IMaterialsShipped;
}

export interface IAnalyticsFilters {
    from: string;
    to: string;
    brandId?: number;
    designId?: number;
}

export const analyticsAtom = atom<WallmatesAnalytics | null>(null);
export const analyticsFiltersAtom = atom<IAnalyticsFilters>({
    from: '',
    to: ''
});

export enum MaterialsShippedViewType {
    DETAILED = 'detailed',
    SUMMARY = 'summary',
    BREAKDOWN = 'breakdown'
}

export interface IMaterialsShippedBreakdown {
    breakdown: IMaterialsShippedData[];
    total_feet: number;
    total_inches: number;
}

export interface IMaterialsSummary {
    total_feet: number;
    total_inches: number;
}

export interface IMaterialsShippedData {
    order_id: number;
    shipped_at: string;
    line_items_count: number;
    panels_total: number;
    base_feet: number;
    separator_count: number;
    separator_inches: number;
    overhead_inches: number;
    total_inches: number;
    feet: number;
    inches: number;
}

export type IMaterialsShipped =
    | IMaterialsShippedBreakdown
    | IMaterialsSummary
    | IMaterialsShippedData[];
